<template>
	<div id="signup-page"><!--class="public"-->
		<Navigation :frontEndUrl="frontEndUrl" :directUrl="directUrl" :partnerUrl="partnerUrl"></Navigation>
		<slot />
		<Footer :frontEndUrl="frontEndUrl"></Footer>
	</div>
</template>
<script>
import Navigation from "@/components/SignupNavigation";
import Footer from "@/components/SignupFooter";
import { IMPROVE_CONFIG } from '@/config.js';

export default {
	name: "LayoutBasic",
	components: {
		Navigation,
		Footer
	},
	data() {
		return {
			frontEndUrl: IMPROVE_CONFIG.FRONTEND_URL,
			directUrl: IMPROVE_CONFIG.DIRECT_URL,
			partnerUrl: IMPROVE_CONFIG.PARTNER_URL
		}
	}
};
</script>